import axios from 'axios';

import type {
  IOnboardingClaimBrokerageBody,
  IOnboardingClaimBrokerageParams,
  IOnboardingClaimBrokerageRequest,
  IOnboardingClaimBrokerageResponse,
} from '@/app-package';

const claimBrokerage = async (
  params: IOnboardingClaimBrokerageParams,
  body: IOnboardingClaimBrokerageBody,
) => {
  const url = `/onboarding/${params.orgClaimHash}/claim_brokerage/${params.submitterHash}`;

  const config: IOnboardingClaimBrokerageRequest = {
    url,
    method: 'post',
    data: body,
  };

  const { data } =
    await axios.request<IOnboardingClaimBrokerageResponse>(config);

  return data;
};

export default claimBrokerage;
